import { Callout, H3, Intent } from '@blueprintjs/core';
import * as React from 'react';

import { notificationsActionCreators } from 'src/actions/notifications/actionCreators';
import { Dropzone } from 'src/components/Dropzone';
import { FileExtension } from 'src/constants/fileExtensions';
import { MAX_FILE_SIZE_IN_MB } from 'src/constants/limits';
import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

type UploadModelFileTileProps = {
  onSelectFile: (file: File) => void;
};

export const UploadModelFileTile: React.VFC<UploadModelFileTileProps> = ({
  onSelectFile,
}) => {
  const dispatch = useReduxDispatch();
  const onDropAccepted = (files: File[]) => {
    if (files[0]) {
      const file = files[0];
      const sizeInMb = file.size / (1024 * 1024);
      if (sizeInMb > MAX_FILE_SIZE_IN_MB) {
        dispatch(notificationsActionCreators.maxFileSizeExceeded());
        return;
      }

      onSelectFile(files[0]);
    }
  };

  return (
    <Callout className="sd-model-type-panel__tile" intent={Intent.NONE}>
      <H3>{copy.components.projectModelDialog.modelTypePanel.upload}</H3>
      <Dropzone
        acceptTypes={FileExtension.TURTLE}
        buttonProps={{
          intent: Intent.PRIMARY,
          large: true,
          text: copy.components.projectModelDialog.modelTypePanel.browseFiles,
        }}
        buttonTestId={
          TEST_IDS.projectModelDialog.modelTypePanel.uploadModel.proceedButton
        }
        onDropAccepted={onDropAccepted}
        text={copy.components.projectModelDialog.modelTypePanel.uploadSubtitle}
      />
    </Callout>
  );
};
